var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showList)?_c('pocket-block',{staticClass:"points-list-wrapper list-blocks__pocket",on:{"close":_vm.close}},[_c('point-list')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }